import React, {useEffect} from 'react';
import {
  Dimensions,
  FlatList,
  Platform,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import Modal from 'react-native-modal';
import {createStyles} from '../../../utils/createStyles';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {
  fetchBookVersions,
  Grade,
  selectBookVersions,
  selectGrades,
} from '../../../store/xueke';
import {UserState} from '../../../store/user';
import {getXkwTerms, XKWTermsRes} from '../../../API/mylearn';
import Toast from 'react-native-toast-message';

const styles = createStyles({
  flex1: {
    flex: 1,
  },
  textPrimary: {
    color: '#000',
    fontSize: 18,
  },
  textSecondary: {
    color: '#666',
    fontSize: 14,
  },
  modalContainerBox: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: '67.85rem',
    height: '85%',
    backgroundColor: '#fff',
    borderRadius: '1rem',
    zIndex: 99,
    flexDirection: 'column',
  },
  modalContainerBoxCon: {
    flexDirection: 'row',
    paddingTop: '2.35rem',
  },
  modalContainerBoxConGrades: {
    width: '15.7rem',
    alignItems: 'center',
    borderRightWidth: 1,
    borderRightColor: '#D8D8D8',
  },
  modalContainerBoxConItem: {
    width: '7.8rem',
    height: '3.2rem',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '1.6rem',
    marginBottom: '1.4rem',
  },
  ActiveItem: {
    backgroundColor: '#EFF4FF',
  },
  modalContainerBoxConVersionItem: {
    width: '15.6rem',
    paddingHorizontal: '1.45rem',
    justifyContent: 'flex-start',
  },
  ActiveItemText: {
    color: '#6658FF',
  },
  modalContainerBoxConItemText: {
    color: '#64617B',
    fontSize: '1.3rem',
  },
  modalContainerBoxConTerm: {
    width: '15.9rem',
    alignItems: 'center',
  },
  SynchroWorkbookBoxConRightTopBox: {
    width: '14.75rem',
    height: '3rem',
    backgroundColor: '#fff',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.75rem',
    zIndex: 999,
  },
  SynchroWorkbookBoxConRightTopBoxText: {
    fontSize: '1.1rem',
    color: '#64617B',
    zIndex: 9999,
  },

  // btn
  modalContainerBoxBtn: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginTop: '3rem',
    marginBottom: '1.05rem',
    paddingLeft: '11.6rem',
  },
  modalContainerBoxBtnItem: {
    width: '12.5rem',
    height: '4.5rem',
    borderRadius: '3.5rem',
    backgroundColor: '#EFF4FF',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainerBoxBtnItemText: {
    fontSize: '1.35rem',
    color: '#3d3d3d',
  },
});

type OverlayProps = {
  isVisible: boolean;
  subjectId: number;
  basicInfoObj: any;
  onBackdropPress: () => void;
  onButtonPress: (
    title: string,
    basicInfo: {grade_id: number; term: string; version_id: number},
  ) => void;
  userInfo: UserState['userInfo'];
};

const OverlaySelect: React.FC<OverlayProps> = ({
  isVisible,
  userInfo,
  subjectId,
  onBackdropPress,
  onButtonPress,
  basicInfoObj,
}) => {
  const deviceWidth = Dimensions.get('window').width;
  const deviceHeight =
    Platform.OS === 'ios'
      ? Dimensions.get('window').height
      : require('react-native-extra-dimensions-android').get(
          'REAL_WINDOW_HEIGHT',
        );
  const dispatch = useAppDispatch();
  const [currentGradeName, setCurrentGradeName] = React.useState('');
  const [currentVersionName, setCurrentVersionName] = React.useState('');
  const [currentTermName, setCurrentTermName] = React.useState('');
  const grades = useAppSelector(selectGrades);
  const versions = useAppSelector(selectBookVersions);
  const [currentGrade, setCurrentGrade] = React.useState(userInfo.grade);
  const changeGrade = (item: Grade) => {
    console.log('item', item);
    setCurrentGrade(item.id);
    setCurrentGradeName(item.name); // 保存名字
  };
  useEffect(() => {
    isVisible && getVersions();
  }, [currentGrade]);
  const [currentVersion, setCurrentVersion] = React.useState<number>(0);
  const getVersions = () => {
    const p = {
      gradeId: currentGrade ? currentGrade : 1,
      subjectId: subjectId,
    };
    console.log('dianjip', p);
    dispatch(fetchBookVersions(p))
      .unwrap()
      .then(res => {
        console.log('bookVersion', res);
        if (res.find(item => item.id === currentVersion)) {
          setCurrentVersion(currentVersion);
        } else {
          setCurrentVersion(res[0].id);
        }
      });
  };
  const [terms, setTerms] = React.useState<XKWTermsRes[]>([]);
  const [currentTerm, setCurrentTerm] = React.useState<string>('');
  const getTermsList = async () => {
    try {
      const res = await getXkwTerms();
      setTerms(res.data);
      console.log('112', res.data);
      // if (currentTerm === '') {
      //   setCurrentTerm(res.data[0].id);
      //   setCurrentTermName(res.data[0].name);
      // }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (isVisible) {
      getTermsList();
      setCurrentGrade(basicInfoObj.grade_id);
      setCurrentTerm(basicInfoObj.term);
      console.log('basicInfoObj', basicInfoObj);
      setCurrentVersion(basicInfoObj.version_id);
      setCurrentGradeName(
        // @ts-ignore
        grades.find(item => item.id === basicInfoObj.grade_id)?.name,
      );
      setCurrentVersionName(
        // @ts-ignore
        versions.find(item => item.id === basicInfoObj.version_id)?.name,
      );
      setCurrentTermName(
        // @ts-ignore
        terms.find(item => item.id === basicInfoObj.term)?.name,
      );
    } else {
      setCurrentGrade(userInfo.grade);
      setCurrentVersion(0);
      setCurrentTerm('');
      // setCurrentGradeName('');
      // setCurrentVersionName('');
      // setCurrentTermName('');
    }
  }, [isVisible]);
  useEffect(() => {
    isVisible && console.log('versions', currentVersion);
  }, [currentVersion]);

  return (
    <>
      <Modal
        style={{margin: 0}}
        isVisible={isVisible}
        onBackdropPress={onBackdropPress}
        deviceHeight={deviceHeight}
        deviceWidth={deviceWidth}>
        <View style={styles.modalContainerBox}>
          <View style={[styles.flex1, styles.modalContainerBoxCon]}>
            <View style={[styles.modalContainerBoxConGrades]}>
              <FlatList
                data={grades as Grade[]}
                showsVerticalScrollIndicator={false}
                renderItem={({item}) => (
                  <TouchableOpacity
                    onPress={() => {
                      changeGrade(item);
                    }}
                    style={[
                      styles.modalContainerBoxConItem,
                      item.id === currentGrade && styles.ActiveItem,
                    ]}>
                    <Text
                      style={[
                        styles.modalContainerBoxConItemText,
                        item.id === currentGrade && styles.ActiveItemText,
                      ]}
                      key={item.id}>
                      {item.name}
                    </Text>
                  </TouchableOpacity>
                )}
              />
            </View>

            <View style={styles.modalContainerBoxConTerm}>
              {terms.map(item => (
                <TouchableOpacity
                  key={item.id}
                  onPress={() => {
                    setCurrentTerm(item.id);
                    setCurrentTermName(item.name); // 保存学期的名称
                  }}
                  style={[
                    styles.modalContainerBoxConItem,
                    item.id === currentTerm && styles.ActiveItem,
                  ]}>
                  <Text
                    style={[
                      styles.modalContainerBoxConItemText,
                      item.id === currentTerm && styles.ActiveItemText,
                    ]}>
                    {item.name}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
            <View>
              <FlatList
                data={versions}
                numColumns={2}
                showsVerticalScrollIndicator={false}
                renderItem={({item}) => (
                  <TouchableOpacity
                    key={item.id}
                    onPress={() => {
                      console.log(111, item);
                      setCurrentVersion(item.id);
                      setCurrentVersionName(item.name); // 保存版本名称
                    }}
                    style={[
                      styles.modalContainerBoxConItem,
                      styles.modalContainerBoxConVersionItem,
                      item.id === currentVersion && styles.ActiveItem,
                    ]}>
                    <Text
                      numberOfLines={1}
                      ellipsizeMode="tail"
                      style={[
                        styles.modalContainerBoxConItemText,
                        item.id === currentVersion && styles.ActiveItemText,
                      ]}
                      key={item.id}>
                      {item.name}
                    </Text>
                  </TouchableOpacity>
                )}
              />
            </View>
          </View>
          <View style={styles.modalContainerBoxBtn}>
            <TouchableOpacity
              style={styles.modalContainerBoxBtnItem}
              onPress={onBackdropPress}>
              <Text style={styles.modalContainerBoxBtnItemText}>取消</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                if (!currentVersion) {
                  Toast.show({
                    type: 'error',
                    text1: '请选择版本',
                  });
                  return;
                }
                onButtonPress(
                  `${currentVersionName}    |    ${currentGradeName}${currentTermName}`,
                  {
                    grade_id: currentGrade ? currentGrade : 0,
                    term: currentTerm,
                    version_id: currentVersion,
                  },
                );
              }}
              style={[
                styles.modalContainerBoxBtnItem,
                {backgroundColor: '#6658FF'},
              ]}>
              <Text
                style={[styles.modalContainerBoxBtnItemText, {color: '#fff'}]}>
                确定
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </>
  );
};

export default OverlaySelect;
